import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import '../scss/tabs-change.scss';

interface IProps {
  onChange: (code: string) => void
  code: string
}
interface IState { }

const timeData = [{
  value: '人数',
  code: 'employee_count_rankings',
}, {
  value: '数量',
  code: 'exchange_count_rankings',
}];

const TabChange = (props: IProps, state: IState) => {
  const { onChange, code } = props;
  const [active, setActive] = useState<string>('');
  useEffect(() => {
    setActive(code);
    return () => { };
  }, [code]);
  const action = (code: string) => {
    setActive(code);
    onChange(code);
  };
  return (
    <section className="welfare-tab-content-01">
      {timeData?.map(item => (
        <p
          aria-hidden="true"
          key={item.code}
          className={item.code === active ? 'tab-item-active' : 'tab-item'}
          onClick={() => action(item.code)}>
          {item.value}
        </p>
      ))}
    </section>
  );
};

export default observer(TabChange);
